/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import messages from '@/i18n';

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: messages.es.validation[rule],
  });
});

export default ({ Vue }) => {
  Vue.component('ValidationObserver', ValidationObserver);
  Vue.component('ValidationProvider', ValidationProvider);
};



// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js